import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import FeatureVisibilityDropdown from '@/components/FeatureVisibility/FeatureVisibilityDropdown.vue';
import { Service, Workflow } from '@ply-io/ply-front-shared-utilities';

import { useInject } from '@/components/SideBar/composables';
import { TileContextMenuFunctionsKey } from '../../types';
import { useWorkflowPermissions } from '@/composables';

interface TileDropdownMenuHeaderProps {
	workflow: Workflow;
	service: Service;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TileDropdownMenuHeader',
  props: {
    workflow: null,
    service: null
  },
  setup(__props: any) {

const props = __props as {
	workflow: Workflow;
	service: Service;
}

const { setIsVisible } = useInject(TileContextMenuFunctionsKey);
const PLY_APP_URL = process.env.VUE_APP_APP_URL;


const workflow = computed<Workflow>(() => props.workflow);
const { canHideWorkflow } = useWorkflowPermissions(workflow.value.id);
const service = computed<Service>(() => props.service);
const serviceSlug = computed(() => service.value?.service_slug);
const isShowingFeature = computed(() => workflow.value?.user_settings?.is_on);

const openFeatureInNewTab = () => window.open(`${PLY_APP_URL}flow-details/${workflow.value.id}`, '_blank');

return { __sfc: true,setIsVisible, PLY_APP_URL, props, workflow, canHideWorkflow, service, serviceSlug, isShowingFeature, openFeatureInNewTab, FeatureVisibilityDropdown }
}

})